// extracted by mini-css-extract-plugin
export default {"modal":"z_UrcDUVO3_xH1Q3QHBw","switchItemParent":"e_6wJB4jYo641ykY0vd8","switchItem":"d5bF_UBDTWSgpaxR6KZv","switchItemLabel":"bwqfoWdS3UKHhQYTRB5I"};